import utils from '@/mixins/utils.js'

// Função para verificar pendências baseada nos alertas da TabelaCadastros.vue
function verificarPendencias(item) {
  // Se não tem escovações supervisionadas, mostra pendência
  if (item.num_escov_dent_super == 0) {
    return 'Escovação dental supervisionada'
  }

  return ''
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    callback: (item) => {
      let idade = `${utils.methods.formatDate(item.dt_nascimento)} (${
        item.idade
      } ${item.idade > 1 ? 'anos' : 'ano'})`
      return idade
    },
  },
  Mãe: 'no_mae',
  'M.Área': 'micro_area',
  Escovação: {
    callback: (item) => {
      return item.dt_ult_escov_dent_super != null
        ? utils.methods.formatDate(item.dt_ult_escov_dent_super)
        : ''
    },
  },
}

export const infoHtml = ``
